import React from 'react';
import {Button, Input, Modal, ModalBody, ModalHeader} from 'reactstrap';
import {I18n} from "../../I18n/components/companyMarket";

const AddPackageModal = (props) => {
	return (
		<Modal className="add-package-modal" isOpen={props.createPackageModal} toggle={props.createPackageModalToggle}>
			<ModalHeader>{I18n[props.lang].addPackage}</ModalHeader>
			<ModalBody>
				<Input
					type="text"
					name="pockets-search"
					id="pockets-search"
					className="pocket-seacrch__input"
					placeholder={I18n[props.lang].namePlaceholder}
					onChange={event => {props.onChangePackageName(event)}}
					value={props.currentPackageName}
				/>
				<div className="add-package-modal__butttons">
					<Button color="secondary" className="ml-1" onClick={props.cancel}>{I18n[props.lang].cancel}</Button>
					<Button
						color="primary"
						className="ml-1"
						onClick={props.addPackage}
						disabled={props.isPackageNameExist}
						data-status={props.isPackageNameExist}
					> {I18n[props.lang].save}
					</Button>
				</div>
			</ModalBody>
		</Modal>
	)
};

export default AddPackageModal;



// WEBPACK FOOTER //
// ./src/components/CompanyMarket/AddPackageModal.js